<template>
  <subscription-plan-content
    :subscription="subscription"
    :readonly="readonly">
    <template v-slot:read-only-options>
      <div>
        <strong>{{ $t('keywords-count') }}</strong> : {{ subscription.options[optionKey] * 100 }}
      </div>
    </template>
    <template v-slot:editable-options>
      <div>
        <v-select
          outlined
          :items="keywordCountItems"
          v-model="keywordCount"
          :label="$t('keywords-count')"
        ></v-select>
      </div>
    </template>
  </subscription-plan-content>
</template>

<script>
import SubscriptionPlanContent from './SubscriptionPlanContent'

export default {
  name: 'SubscriptionPlanContentCheckPosition',
  components: { SubscriptionPlanContent },
  props: ['subscription', 'readonly'],
  computed: {
    optionKey () {
      return this.subscription.optionKey
    },
    keywordCount: {
      set (value) {
        this.$set(this.subscription.options, this.optionKey, value / 100)
      },
      get () {
        return this.subscription.options[this.optionKey] * 100
      }
    },
    keywordCountItems () {
      const items = []
      for (let i = 1; i <= 200; i++) {
        items.push({
          text: this.$t('keyword-count-items', { count: i * 100, price: this.getKeywordPrice(i) }),
          value: i * 100,
        })
      }
      return items
    }
  },
  watch: {
    keywordCount (value) {
      this.$set(this.subscription.options, this.optionKey, value / 100)
    }
  },
  methods: {
    getKeywordPrice (count) {
      const prices = this.subscription.moduleConfig.plan.options[this.optionKey].stripe.prices
      if (this.subscription.yearly) {
        return this.$helpers.present.currency(prices.year.amount / 12 * count) + ' / ' + this.$t('dates.monthly')
      } else {
        return this.$helpers.present.currency(prices.month.amount * count) + ' / ' + this.$t('dates.monthly')
      }
    }
  },
  mounted () {
    if (this.subscription.options[this.optionKey] < 1) {
      this.$set(this.subscription.options, this.optionKey, 1)
    }
  }
}
</script>

<style scoped>

</style>

<i18n>
{
	"en": {
		"keyword-count-items": "Up to {count} keywords ({price})",
		"keywords-count": "Number of keywords"
	},
	"es": {
		"keyword-count-items": "Hasta {count} palabras clave ({price})",
		"keywords-count": "Número de palabras clave"
	},
	"fr": {
		"keyword-count-items": "Jusqu'à {count} mots clés ({price})",
		"keywords-count": "Nombre de mots clés"
	},
	"it": {
		"keyword-count-items": "Fino a {count} parole chiave ({price})",
		"keywords-count": "Numero di parole chiave"
	},
	"pt": {
		"keyword-count-items": "Até {count} palavras-chave ({price})",
		"keywords-count": "Número de palavras-chave"
	},
	"pl": {
		"keyword-count-items": "Do {count} słów kluczowych ({price})",
		"keywords-count": "Liczba słów kluczowych"
	}
}
</i18n>
